// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"61301432","69":"1b99ab5f","229":"159c36ae","284":"cfaa3786","453":"7106f4e7","494":"8bf904e0","576":"a6bccc6c","602":"a5a2c6f5","638":"d0041af1"}[chunkId] + ".chunk.js";
};